import { GET_QUIZ_CATEGORIES } from "constants/quizCategories";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_QUIZ_CATEGORIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
